export const MessengerIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M34 9H6V12.11L20 22.93L34 12.11V9Z" fill="black" />
      <path d="M10.02 19.36V26.98H29.98V19.36L34 16.26V31H6V16.26L10.02 19.36Z" fill="black" />
    </svg>
  )
}
